var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper w-100"},[_c('div',{staticClass:"bg-red"}),_c('div',{staticClass:"footer-powered-by"},[_c('div',{staticClass:"img-container px-5 py-1",on:{"click":_vm.goToLgame}},[_c('a',{on:{"click":_vm.goToLgame}},[_c('img',{attrs:{"src":require("@/assets/imgs/lgame/powered-by.png"),"height":"18px","alt":"Lgame"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }